import { render, staticRenderFns } from "./DropdownUser.vue?vue&type=template&id=41dc3ce2"
import script from "./DropdownUser.vue?vue&type=script&lang=js"
export * from "./DropdownUser.vue?vue&type=script&lang=js"
import style0 from "./DropdownUser.vue?vue&type=style&index=0&id=41dc3ce2&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41dc3ce2')) {
      api.createRecord('41dc3ce2', component.options)
    } else {
      api.reload('41dc3ce2', component.options)
    }
    module.hot.accept("./DropdownUser.vue?vue&type=template&id=41dc3ce2", function () {
      api.rerender('41dc3ce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/extras/dropdown/DropdownUser.vue"
export default component.exports